export default "__VITE_ASSET__DdtMnUfp__"